/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GraduatoriaScorrimentoPianoRigaDTO } from './graduatoria-scorrimento-piano-riga-dto';


export interface GraduatoriaScorrimentoPianoDTO { 
    graduatoria_id?: string;
    graduatoria_nome?: string;
    righe?: Array<GraduatoriaScorrimentoPianoRigaDTO>;
}

